// polyfills
import 'es6-promise/auto' // IE11, makes unpoly work
import 'string.prototype.startswith' // IE11
import 'core-js/stable'
import 'focus-visible'

// from https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.matchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector ||
    Element.prototype.oMatchesSelector ||
    Element.prototype.webkitMatchesSelector
}

// Polyfill for using `new Event()` in IE. Adapted from
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
;(function () {
  if (typeof window.Event === 'function') return false

  function Event(event, params) {
    params = params || { bubbles: false, cancelable: false, composed: false }
    const evt = document.createEvent('Event')
    evt.initEvent(event, params.bubbles, params.cancelable, params.composed)
    return evt
  }

  window.Event = Event
})()
